import { IoIosArrowRoundBack } from 'react-icons/io';
import { DARK_GRAY } from '../../../styles/constants/color';
import styled from '@emotion/styled';

const Button = styled.button`
  width: auto;
  height: auto;

  > svg {
    width: auto;
    height: auto;
  }
`;

interface Props {
  onClick: () => void;
}

/**
 * 이전 버튼 컴포넌트
 * @param {Function} onClick onClick 함수
 *  */
function PrevButton({ onClick }: Props): JSX.Element {
  return (
    <Button onClick={onClick}>
      <IoIosArrowRoundBack size={45} color={DARK_GRAY} />
    </Button>
  );
}

export default PrevButton;
